module.exports = __webpack_public_path__ + "img/broken-image.2f937579.svg";